import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { CSSProperties, SyntheticEvent } from 'react';
import { IdName } from '../../models/global';

interface DropdownProps {
  size?: 'small' | 'medium';
  value: string | IdName;
  options: any[];
  onChange: (e: SyntheticEvent, value: string | IdName) => void;
  width?: number;
  style?: CSSProperties;
  label: string;
  error?: boolean;
  required?: boolean;
  disabled?: boolean;
  disableClearable?: boolean;
  isFullWidth?: boolean;
}

function Dropdown(props: DropdownProps) {
  const filterOptions = createFilterOptions({
    limit: 50,
  });
  return (
    <Autocomplete
      disablePortal
      size={props.size || 'small'}
      value={props.value}
      options={props.options}
      onChange={props.onChange}
      sx={{ width: props.isFullWidth ? '100%' : props.width | 300 }}
      style={props.style}
      renderInput={params => (
        <TextField {...params} label={props.label} error={props.error} required={!!props.required} />
      )}
      renderOption={(props, item) => (
        <li {...props} key={item?.id || item}>
          {item?.name || item}
        </li>
      )}
      getOptionLabel={option => option?.name || option}
      disabled={props.disabled || false}
      disableClearable={props.disableClearable || false}
      filterOptions={filterOptions}
    />
  );
}

export default Dropdown;
